<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <span>{{ this.$lang.evidence + " " + $lang.indicator + " " }}</span>
            <strong v-text="entityId[3]"></strong>
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.select_evidence"
              label-for="evidence_text"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.evidence"
                :rules="$v.evidence_text.$params"
              />
              <b-row>
                <b-col cols="10">
                  <b-form-textarea
                    id="description"
                    :state="
                      $v.evidence_text.$dirty ? !$v.evidence_text.$error : null
                    "
                    v-model="$v.evidence_text.$model"
                    type="text"
                    :autocomplete="$lang.evidence"
                    :rows="this.$config.form.textareaRows"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="description-feedback">{{
                    $lang.error_required | replace($lang.evidence_text)
                  }}</b-form-invalid-feedback>
                </b-col>
                <b-col cols="2">
                  <b-button
                    class="ml-2"
                    size="md"
                    variant="success"
                    v-text="$lang.select_evidence"
                    @click="showEvindence"
                  ></b-button>
                </b-col>
              </b-row>

              <b-form-invalid-feedback id="evidence_text-feedback">{{
                $lang.error_required | replace($lang.evidence)
              }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.error_code"
              label-for="error_code_selected"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.error_code"
                :rules="$v.error_code_selected.$params"
              />
              <selectFind
                :options="error_code_options"
                v-model="$v.error_code_selected.$model"
                label="text"
                id="value"
                :isValid="
                  $v.error_code_selected.$dirty
                    ? !$v.error_code_selected.$error
                    : null
                "
                :loading="error_codeLoading"
              />

              <b-form-invalid-feedback id="error_code-feedback">{{
                $lang.error_required | replace($lang.error_code)
              }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-for="value" :label-cols="12">
              <requiredComponent
                slot="label"
                :label="$lang.status"
                :rules="$v.status.$params"
              />
              <b-form-radio-group
                id="value"
                v-model="$v.status.$model"
                :state="$v.status.$dirty ? !$v.status.$error : null"
                :options="status_options"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>

            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>

          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>

    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_evidence_modal"
      :title="$lang.evidence"
      size="xl"
      :ok-title="$lang.submit"
      :cancel-title="$lang.cancelButton"
    >
      <selectSearch
        :title="$lang.evidence"
        :url="evidence_url"
        v-model="evidenceSelected"
        :limitOneSelect="false"
      ></selectSearch>
      <template v-slot:modal-footer>
        <b-button
          variant="danger"
          @click="
            cancelEvidence();
            view_evidence_modal = false;
          "
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import selectSearch from "@/components/base/selectSearch";

export default {
  validations: {
    evidence_text: {
      required,
    },
    error_code_selected: {},
    evidences: {},
    status: {},
  },
  name: "edit-center_execute_case_competency_evidence",
  components: { selectSearch },
  props: {
    mode: {
      type: String,
      default: "add",
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },

    entityId: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      status: null,
      status_options: [
        { value: "-1", text: this.$lang.no_authentication },
        { value: "0", text: this.$lang.not_authenticated },
        { value: "1", text: this.$lang.authenticated },
        { value: "2", text: this.$lang.strongly_authenticated },
      ],
      center_execute_id: this.entityId[0],
      center_execute_case_id: this.entityId[1],
      competency_id: this.entityId[6],
      template_competency_indicator_exercise_id: "",
      error_code: "",
      error_code_options: [],
      error_code_selected: {},
      evidences_options: [],
      evidence_text: "",
      evidences: "",
      isLoading: false,
      error_codeLoading: false,
      evidencesLoading: false,
      evidence_url: this.$config.api_url + this.$config.kanoon.evidence,
      evidenceSelected: [],
      view_evidence_modal: false,
    };
  },
  methods: {
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.description = "";
    },
    changes() {},
    showEvindence() {
      this.view_evidence_modal = true;
    },
    addEvidences() {},
    cancelEvidence() {},
    getTextEvidence() {
      return this.$httpService
        .get(
          this.$config.api_url + this.$config.kanoon.evidence + "?is_enable=1"
        )
        .then((response) => {
          if (response.status !== 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let evidences = response.data.data;
          evidences = evidences.map((x) => {
            return {
              value: x.id,
              text: x.evidence_text,
            };
          });
          this.evidences_options = evidences;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    getErrorCodes() {
      return this.$httpService
        .get(this.$config.api_url + this.$config.metaData.error_code)
        .then((response) => {
          if (response.status !== 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let error_code = response.data.data;
          error_code = error_code.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          error_code.push({
            value: -1,
            text: this.$lang.without_error,
          });
          this.error_code_options = error_code;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    save() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }

      let error_code_selected_value = -1;
      if (typeof this.error_code_selected === "object") {
        error_code_selected_value = this.error_code_selected.value;
      }

      let payload = {
        // status: 1,
        status: this.status,
        error_code: error_code_selected_value,
        evidence_id: this.evidenceSelected[0].id,
        evidence_text: this.evidence_text,
      };

      this.$httpService
        .put(
          this.$config.api_url +
            this.$config.kanoon.center_execute_case_evidence
              .replace("{0}", this.center_execute_id)
              .replace("{1}", this.$route.params.case_id)
              .replace("{2}", this.template_competency_indicator_exercise_id),
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.afterSave();
        })
        .catch((err) => {});
    },
    fetchData() {
      if (isNaN(this.center_execute_id) || isNaN(this.center_execute_case_id)) {
        this.$notify.error("Not a number!");
        return false;
      }
      this.$httpService
        .get(
          (this.url_get_exercise =
            this.$config.api_url +
            this.$config.kanoon.template_competency_indicator_exercise
              .replace("{0}", this.entityId[4])
              .replace("{1}", this.competency_id)
              .replace("{2}", this.entityId[2]) +
            "/" +
            this.entityId[5])
        )
        .then((response) => {
          let data = response.data.data;

          this.template_competency_indicator_exercise_id = data.id;

          this.$httpService
            .get(
              this.$config.api_url +
                this.$config.kanoon.center_execute_case_evidence
                  .replace("{0}", this.$route.params.center_execute_id)
                  .replace("{1}", this.$route.params.case_id)
                  .replace(
                    "{2}",
                    this.template_competency_indicator_exercise_id
                  ) +
                "?is_enable=1"
            )
            .then((response) => {
              let data = response.data.data;
              this.error_code = data.error ? data.error.id : null;
              this.getErrorCodes()
                .then((response) => {
                  this.error_code_selected = this.error_code_options.find(
                    (x) => x.value === this.error_code
                  );
                })
                .catch((error) => {
                  this.$generateError(error);
                })
                .finally(() => (this.isLoading = false));

              this.name = data.name;
              this.evidence_text = data.evidence_text;
              this.evidenceSelected = data.evidence ? [data.evidence] : [];

              this.status = data.status ? data.status.id : null;
            })
            .catch((error) => {
              this.$generateError(error);
            })
            .finally(() => {
              this.isLoading = false;
              if (this.error_code_options.length == 0) {
                this.getErrorCodes()
                  .catch((error) => {
                    this.$generateError(error);
                  })
                  .finally(() => (this.isLoading = false));
              }
            });
        })
        .catch((error) => {
          this.$generateError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  watch: {
    evidenceSelected() {
      if (this.evidenceSelected && this.evidenceSelected[0]) {
        this.evidence_text = this.evidenceSelected
          .map((x) => x.evidence)
          .join("\n");
      }
    },
  },
  computed: {},
  created() {
    this.evidence_url =
      this.$config.api_url +
      this.$config.kanoon.center_execute_evidence
        .replace("{id}", this.entityId[0])
        .replace("{competency_id}", this.entityId[6])
        .replace("{indicator_id}", this.entityId[2])
        .replace("{exercise_id}", this.entityId[5]);
    this.isLoading = true;
    // this.getTextEvidence();
    this.fetchData();
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
